import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProjectQuery } from "../../features/projects/projectsApi";
import { useAddTaskMutation } from "../../features/tasks/tasksApi";
import { useGetTeamQuery } from "../../features/team/teamApi";

const AddTask = () => {
  const [taskName, setTaskName] = useState("");
  const [teamMember, setTeamMember] = useState("");
  const [projectName, setProjectName] = useState("");
  const [deadline, setDeadline] = useState("");

  const { data: project } = useGetProjectQuery(projectName, {
    skip: !projectName,
  });
  
  const { data: team } = useGetTeamQuery(teamMember, {
    skip: !teamMember,
  });

  const [addTask, { isLoading }] = useAddTaskMutation();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    addTask({
      taskName,
      teamMember: team[0],
      project: project[0],
      deadline,
    });
    navigate("/");
  };

  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Create Task for Your Team
        </h1>

        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="fieldContainer">
              <label for="lws-taskName">Task Name</label>
              <input
                type="text"
                name="taskName"
                id="lws-taskName"
                required
                value={taskName}
                placeholder="Implement RTK Query"
                onChange={(e) => setTaskName(e.target.value)}
              />
            </div>

            <div className="fieldContainer">
              <label>Assign To</label>
              <select
                name="teamMember"
                id="lws-teamMember"
                required
                value={teamMember}
                onChange={(e) => setTeamMember(e.target.value)}
              >
                <option value="" hidden selected>
                  Select Job
                </option>
                <option>Sumit Saha</option>
                <option>Sadh Hasan</option>
                <option>Akash Ahmed</option>
                <option>Md Salahuddin</option>
                <option>Riyadh Hassan</option>
                <option>Ferdous Hassan</option>
                <option>Arif Almas</option>
              </select>
            </div>
            <div className="fieldContainer">
              <label for="lws-projectName">Project Name</label>
              <select
                id="lws-projectName"
                name="projectName"
                required
                value={projectName}
                onChange={(e) => setProjectName(e.target.value)}
              >
                <option value="" hidden selected>
                  Select Project
                </option>
                <option>Scoreboard</option>
                <option>Flight Booking</option>
                <option>Product Cart</option>
                <option>Book Store</option>
                <option>Blog Application</option>
                <option>Job Finder</option>
              </select>
            </div>

            <div className="fieldContainer">
              <label for="lws-deadline">Deadline</label>
              <input
                type="date"
                name="deadline"
                id="lws-deadline"
                required
                value={deadline}
                onChange={(e) => setDeadline(e.target.value)}
              />
            </div>

            <div className="text-right">
              <button type="submit" className="lws-submit" disabled={isLoading}>
                Save
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddTask;
